export default "__VITE_ASSET__CD4E$UTL__"